import axios from "axios";

// Axios instance pre-configured to send cookies and target the backend URL.
// We also support Bearer-token auth via localStorage (tots360-session-token) for
// cross-origin deployments where the edge proxy's CORS policy conflicts with cookies.
const SESSION_STORAGE_KEY = "tots360-session-token";

export const getStoredToken = () =>
  typeof window !== "undefined" ? window.localStorage.getItem(SESSION_STORAGE_KEY) : null;

export const setStoredToken = (token) => {
  if (typeof window === "undefined") return;
  if (token) window.localStorage.setItem(SESSION_STORAGE_KEY, token);
  else window.localStorage.removeItem(SESSION_STORAGE_KEY);
};

const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true,
});

// Attach Bearer token automatically (primary path on cross-origin production)
api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

// Normalize FastAPI's error detail (string OR Array<{msg}>) to a user-friendly string.
export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" • ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
